import React, { Component } from 'react';
import * as encryptUtils from "./encryptDecryptUtils";
import * as loggingUtils from "./utils/loggingUtils";

class ComingLivestreamItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="w-screen mt-10">
        <div className="ml-10 font-bold text-zinc-900 dark:text-white text-4xl font-semibold">
          UPCOMING LIVESTREAMS
        </div>
        <div key={this.props.key}>
          <div className="ml-10 mt-8 w-[400px] h-80 inline-block bg-gradient-to-br from-custom-black via-zinc-800 to-custom-black shadow-2xl rounded-xl mx-2">
            <img
              className="w-[400px] h-[230px] object-cover inline-block cursor-pointer rounded-xl"
              src={this.props.image}
              onClick={()=> {
                window.open(window.location.origin + this.props.itemRoute, "_self")
              }}
              alt='/'
            />
            <div className="flex items-center h-[90px]">
              <img
                className="ml-4 w-8 h-8 rounded-full"
                src={this.props.creatorImage}
                onClick={()=> {
                  window.open(window.location.origin + this.props.itemRoute, "_self")
                }}
              />
              <div>
                <div className="ml-4 dark:text-white text-black flex font-semibold"
                  onClick={()=> {
                    window.open(window.location.origin + this.props.itemRoute, "_self")
                  }}
                >
                  {this.props.itemName}
                </div>
                <div className="ml-4 dark:text-zinc-400 text-sm text-zinc-200 flex font-semibold hover:underline"
                  onClick={()=> {
                    window.open(window.location.origin + this.props.itemRoute, "_self")
                  }}
                >
                  {this.props.creatorName}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ComingLivestreamItem;
